import { z } from 'zod'

export const referralOwnerTypes = ['business', 'user'] as const
export const referralOwnerTypeSchema = z.enum(referralOwnerTypes)

export const referralSorts = ['invited', 'active', 'created_at'] as const
export const referralSortSchema = z.enum(referralSorts)

export const referralAttributionStatusSchema = z.enum(['pending', 'active', 'reverted'])
export const referralInviteeKindSchema = z.enum(['user', 'business'])

export const REFERRALS_MAX_PER_PAGE = 500
export const REFERRAL_REVERT_REASON_MAX = 500

const isoDate = z.iso.datetime().nullable()

export const referralOwnerRowSchema = z.object({
  code: z.string(),
  ownerType: referralOwnerTypeSchema,
  ownerId: z.number(),
  ownerName: z.string().nullable(),
  ownerEmail: z.string().nullable(),
  invited: z.number(),
  users: z.number(),
  businesses: z.number(),
  active: z.number(),
  suspicious: z.number(),
  createdAt: isoDate,
})

export const referralsListResponseSchema = z.object({
  available: z.boolean(),
  rows: z.array(referralOwnerRowSchema),
  total: z.number(),
  page: z.number(),
  perPage: z.number(),
})

export const referralAttributionSchema = z.object({
  id: z.number(),
  invitee: z.object({
    id: z.number(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    registeredAt: isoDate,
  }),
  kind: referralInviteeKindSchema,
  business: z.object({ id: z.number(), title: z.string() }).nullable(),
  status: referralAttributionStatusSchema,
  source: z.string(),
  suspicious: z.boolean(),
  suspiciousReason: z.string().nullable(),
  createdAt: isoDate,
  activatedAt: isoDate,
  revertedAt: isoDate,
  revertReason: z.string().nullable(),
})

export const referralOwnerDetailSchema = z.object({
  code: z.string(),
  ownerType: referralOwnerTypeSchema,
  ownerId: z.number(),
  ownerName: z.string().nullable(),
  ownerEmail: z.string().nullable(),
  link: z.string(),
  stats: z.object({
    invited: z.number(),
    users: z.number(),
    businesses: z.number(),
    active: z.number(),
    reverted: z.number(),
  }),
  createdAt: isoDate,
  attributions: z.array(referralAttributionSchema),
})

export const referralRevertRequestSchema = z.object({
  reason: z
    .string({ error: 'Укажите причину отмены.' })
    .trim()
    .min(1, 'Укажите причину отмены.')
    .max(REFERRAL_REVERT_REASON_MAX, `Причина — не длиннее ${REFERRAL_REVERT_REASON_MAX} символов.`),
})

export type ReferralOwnerType = z.infer<typeof referralOwnerTypeSchema>
export type ReferralSort = z.infer<typeof referralSortSchema>
export type ReferralAttributionStatus = z.infer<typeof referralAttributionStatusSchema>
export type ReferralInviteeKind = z.infer<typeof referralInviteeKindSchema>
export type ReferralOwnerRow = z.infer<typeof referralOwnerRowSchema>
export type ReferralsListResponse = z.infer<typeof referralsListResponseSchema>
export type ReferralAttribution = z.infer<typeof referralAttributionSchema>
export type ReferralOwnerDetail = z.infer<typeof referralOwnerDetailSchema>
export type ReferralRevertRequest = z.infer<typeof referralRevertRequestSchema>
